import React from 'react';
import './About.scss';
import aboutimage from '../images/About.jpeg'
const AboutUs = () => {
    return (
        <section className="about-us">
            <div className="image">
                <img src={aboutimage} alt="About Us Image" />
            </div>
            <div className="text">
                <h2>About Us</h2>
                <p>English Enclave is a vibrant, online student-led profit organization , dedicated to enhancing the English skills of non-native speakers from around the world.</p>
            </div>
        </section>
    );
};

export default AboutUs;
